import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { IntroInsurranceValidationPage } from './intro-insurrance-validation';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    IntroInsurranceValidationPage,
  ],
  imports: [
    IonicPageModule.forChild(IntroInsurranceValidationPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class IntroInsurranceValidationPageModule {}



// WEBPACK FOOTER //
// ./src/pages/intro-insurrance-validation/intro-insurrance-validation.module.ts